import { Modal, modalWidth } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import DropdownMenu from "shared/components/DropdownMenu"
import { Editor } from "shared/hubrise/editor"
import { ICatalogSummary } from "shared/hubrise/models"

import DeleteModalContent from "./DeleteModalContent"
import DuplicateModalContent from "./DuplicateModalContent"
import RenameModalContent from "./RenameModalContent"

interface CatalogActionsProps {
  menuLink: ({ onClick }: { onClick: () => void }) => JSX.Element
  catalogSummary: ICatalogSummary
  catalogSummaries: Array<ICatalogSummary>
  editor: Editor | undefined
  setDuplicationInProgress: (state: boolean) => void
  redirectAfterDelete?: string
}

type ModalName = "rename" | "duplicate" | "delete"

const CatalogActions = ({
  menuLink,
  catalogSummary,
  catalogSummaries,
  editor,
  setDuplicationInProgress,
  redirectAfterDelete,
}: CatalogActionsProps): JSX.Element => {
  const [openModal, setOpenModal] = React.useState<ModalName | null>(null)

  const { t } = useTranslation()

  return (
    <>
      <DropdownMenu
        link={menuLink}
        actions={[
          {
            label: t("catalogs.actions.rename.action"),
            onClick: () => setOpenModal("rename"),
          },
          {
            label: t("catalogs.actions.duplicate.action"),
            onClick: () => setOpenModal("duplicate"),
          },
          {
            label: t("catalogs.actions.delete.action"),
            onClick: () => setOpenModal("delete"),
            disabled: catalogSummaries.length === 1,
          },
        ]}
      />

      {openModal === "delete" && (
        <Modal
          modalWidth={modalWidth.small}
          onClose={() => setOpenModal(null)}
          renderContent={({ close }) => (
            <DeleteModalContent {...{ catalogSummary, catalogSummaries, close, redirectAfterDelete }} />
          )}
        />
      )}

      {openModal === "duplicate" && (
        <Modal
          modalWidth={modalWidth.small}
          onClose={() => setOpenModal(null)}
          renderContent={({ close }) => (
            <DuplicateModalContent
              {...{ catalogSummary, catalogSummaries, catalog: editor?.catalog, setDuplicationInProgress, close }}
            />
          )}
        />
      )}

      {openModal === "rename" && (
        <Modal
          modalWidth={modalWidth.small}
          onClose={() => setOpenModal(null)}
          renderContent={({ close }) => <RenameModalContent {...{ catalogSummary, catalogSummaries, editor, close }} />}
        />
      )}
    </>
  )
}

export default CatalogActions
